<template>
  <div>
    <BookUserBar v-if="customer" class="flex-none h-10 bg-accent" />
    <div class="grid w-screen min-h-screen lg:grid-cols-3 bg-gray-50">
      <div class="fixed z-0 w-full p-6 lg:relative lg:h-full lg:col-span-1 lg:p-12">
        <div class="flex items-center justify-between">
          <div class="text-lg leading-tight">
            <div class="font-bold">
              Booking Success
            </div>
            <div class="text-gray-500">
              {{ portal.name }}
            </div>
          </div>
          <div>
            <img :src="portal.logo" v-if="portal.logo" :alt="portal.name" class="w-auto h-10">
          </div>
        </div>
      </div>
      <div class="relative z-10 h-full mt-24 bg-white shadow rounded-t-xl lg:shadow-none lg:rounded-t-none lg:mt-0 lg:col-span-2">
        <Loading v-if="loading" class="p-12" />
        <div v-else class="p-6 mx-auto space-y-8 lg:max-w-3xl lg:p-12">
          <!-- Complete -->
          <div class="flex items-center">
            <checkmark size="2rem" :color="`rgb(${colors[portal.color]})`" class="w-8 mr-4" />
            <div class="text-lg leading-tight">
              <div class="font-bold">
                Thank you, {{ booking.customer_name }}!
              </div> 
              <div class="text-gray-500">
                Your booking has been received.
              </div>
            </div>
          </div>
          <!-- Date & Tme -->
          <div v-if="booking.date || booking.time">
            <div class="h-6 text-xs font-bold tracking-wider text-gray-500 uppercase">
              <span v-if="booking.date">Date</span> 
              <span v-if="booking.date && booking.time">&amp;</span> 
                <span v-if="booking.time">Time</span>
            </div>
            <div class="p-5 mt-2 bg-white border rounded-md shadow-sm">
              <div class="items-center text-sm sm:flex" v-if="booking.date">
                <div class="flex-grow">
                  <div class="w-full max-w-xs font-medium truncate">
                    {{ booking.date | moment('ddd, Do MMMM YYYY') }}
                  </div>
                </div>
              </div>
              <div class="items-center text-sm text-gray-500 sm:flex" v-if="booking.time">
                <div class="flex-grow">
                  <div class="w-full max-w-xs truncate">
                    From {{ booking.time }} 
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Pickups -->
          <div v-if="booking.origins && booking.origins.length">
            <div class="flex items-center justify-between h-6 text-xs font-bold tracking-wider text-gray-500 uppercase">
              {{ booking.origins | pluralize('Pickup') }}
            </div>
            <div class="mt-2 bg-white border rounded-md shadow-sm">
              <div class="p-5 text-sm">
                <div v-for="(origin, index) in booking.origins" :key="origin.id">
                  <hr class="my-4" v-if="index !== 0">
                  <div class="items-center justify-between sm:flex">
                    <div class="pr-3">
                      <div class="font-medium">{{ origin.name || origin.contact_name || 'No Contact Set' }}</div>
                      <div class="w-full max-w-xs text-gray-500 truncate lg:max-w-md">{{ origin.formatted_address || 'No Address Set' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Deliveries -->
          <div v-if="booking.destinations && booking.destinations.length">
            <div class="flex items-center justify-between h-6 text-xs font-bold tracking-wider text-gray-500 uppercase">
              {{ booking.destinations | pluralize(['Delivery', 'Deliveries']) }}
            </div>
            <div class="mt-2 bg-white border rounded-md shadow-sm">
              <div class="p-5 text-sm">
                <div v-for="(destination, index) in booking.destinations" :key="destination.id">
                  <hr class="my-4" v-if="index !== 0">
                  <div class="items-center justify-between sm:flex">
                    <div class="pr-3">
                      <div class="font-medium">{{ destination.name || destination.contact_name || 'No Contact Set' }}</div>
                      <div class="w-full max-w-xs text-gray-500 truncate lg:max-w-md">{{ destination.formatted_address || 'No Address Set' }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Actions -->
          <div>
            <button class="btn btn-secondary" @click="restart">
              Place Another
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import Checkmark from '@/components/Checkmark'
import BookUserBar from '@/views/book/BookUserBar'

export default {
  name: 'BookSuccess',

  components: {
    Checkmark,
    BookUserBar
  },

  computed: {
    ...mapState(['colors', 'portal']),
    ...mapState('booking', ['form']),
    ...mapState('customer', ['customer'])
  },

  async created () {
    await this.getBooking()
    this.resetForm()

    if (this.$cookies.get('customer_token')) {
      await this.syncCustomer()
    }
  },

  data () {
    return {
      loading: true
    }
  },

  methods: {
    ...mapMutations('booking', ['resetForm']),
    ...mapActions('customer', ['syncCustomer']),

    restart () {
      this.resetForm()
      this.$router.push({ name: 'Booking', params: { id: this.$route.params.id } })
    },

    async getBooking () {
      try {
        const { data } = await this.$api.get(`waybills/${this.$route.query.booking}`)
        this.booking = data.booking
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>